module.exports = __webpack_public_path__ + "media/companies/Alexa_Capital-42621eae.png";